import React from 'react';
import PartnerCard from './PartnerCard';
import type { Partner } from '@/hooks/usePartners';

interface PartnerCategoryProps {
  category: string;
  partners: Partner[];
  hideHeading?: boolean;
}

const PartnerCategory: React.FC<PartnerCategoryProps> = ({ category, partners, hideHeading = false }) => {
  if (!partners.length) return null;

  return (
    <section className="mb-16">
      {!hideHeading && (
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold text-primary mb-4">{category}</h3>
          <div className="w-16 h-1 bg-secondary-brand mx-auto"></div>
        </div>
      )}
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {partners.map((partner) => (
          <PartnerCard key={partner.id} partner={partner} />
        ))}
      </div>
    </section>
  );
};

export default PartnerCategory;